(() => {
  if (window.__puffyShopifyChatTrigger) return;
  window.__puffyShopifyChatTrigger = true;

  const triggerSelector = '[data-open-shopify-chat]';
  const retryDelay = 100;
  const retryLimit = 80;

  const getChatActivator = () => {
    const chat = document.querySelector('shopify-chat');
    return chat?.shadowRoot?.querySelector('button[part~="activator"]') || null;
  };

  const openChat = (trigger) => {
    if (trigger.getAttribute('aria-busy') === 'true') return;

    trigger.setAttribute('aria-busy', 'true');
    let attempts = 0;

    const tryActivator = () => {
      const activator = getChatActivator();

      if (activator) {
        if (activator.getAttribute('aria-expanded') !== 'true') activator.click();
        trigger.removeAttribute('aria-busy');
        return;
      }

      attempts += 1;
      if (attempts < retryLimit) {
        window.setTimeout(tryActivator, retryDelay);
      } else {
        trigger.removeAttribute('aria-busy');
      }
    };

    tryActivator();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(triggerSelector);
    if (!trigger) return;

    event.preventDefault();
    openChat(trigger);
  });
})();
